import { ShuttleStatusLogList } from './../model/shuttle-status-log-list';
import { Shuttle } from '../model/shuttle';
import { ShuttleList } from './../model/shuttle-list';
import { ShuttleInfoPanel } from './../model/shuttle-info-panel';
import { ShuttleInfoPanelList } from './../model/shuttle-info-panel-list';
import { ShuttlePanelSlide } from './../model/shuttle-panel-slide';
import { ShuttlePanelSlideList } from './../model/shuttle-panel-slide-list';
import { ShuttleStatusLog } from './../model/shuttle-status-log';
export class ShuttleBuilder {
    static buildShuttle(data) {
        let shuttle = new Shuttle();
        shuttle.id = data.id;
        shuttle.name = data.name;
        shuttle.id_lot = data.id_lot;
        shuttle.status = data.status;
        shuttle.last_updated = data.last_updated;
        shuttle.lat = data.lat;
        shuttle.lng = data.lng;
        shuttle.id_geofence = data.id_geofence;
        shuttle.prediction = data.prediction;
        shuttle.prediction_timestamp = data.prediction_timestamp;
        shuttle.id_terminal = data.id_terminal;
        shuttle.id_user = data.id_user;
        shuttle.user_name = data.user_name;
        shuttle.id_terminal_2 = data.shuttle_terminal_2;
        shuttle.id_terminal_3 = data.shuttle_terminal_3;
        shuttle.id_terminal_4 = data.shuttle_terminal_4;
        return shuttle;
    }
    static buildShuttleList(data) {
        const shuttleList = new ShuttleList();
        shuttleList.pagination = data.pagination;
        shuttleList.page = data.page;
        shuttleList.totalCount = data.total;
        shuttleList.totalPages = data.total_pages;
        shuttleList.shuttles = _.map(data.shuttles, (shuttle) => {
            return this.buildShuttle(shuttle);
        });
        return shuttleList;
    }
    static buildShuttleStatusLogsList(data) {
        const shuttleStatusLogList = new ShuttleStatusLogList();
        shuttleStatusLogList.pagination = data.pagination;
        shuttleStatusLogList.page = data.page;
        shuttleStatusLogList.totalCount = data.total;
        shuttleStatusLogList.totalPages = data.total_pages;
        shuttleStatusLogList.shuttleStatusLogs = _.map(data.shuttle_logs, (shuttleStatusLog) => {
            return this.buildShuttleStatusLog(shuttleStatusLog);
        });
        return shuttleStatusLogList;
    }
    static buildShuttleStatusLog(data) {
        let shuttleStatusLog = new ShuttleStatusLog();
        shuttleStatusLog.id = data.id;
        shuttleStatusLog.id_shuttle = data.id_shuttle;
        shuttleStatusLog.status = data.status;
        shuttleStatusLog.timestamp = data.timestamp;
        shuttleStatusLog.lat = data.lat;
        shuttleStatusLog.lng = data.lng;
        shuttleStatusLog.shuttle_name = data.shuttle_name;
        shuttleStatusLog.id_geofence = data.id_geofence;
        shuttleStatusLog.prediction = data.prediction;
        shuttleStatusLog.prediction_timestamp = data.prediction_timestamp;
        shuttleStatusLog.id_terminal = data.id_terminal;
        shuttleStatusLog.id_lot = data.id_lot;
        shuttleStatusLog.id_user = data.id_user;
        shuttleStatusLog.status_change = data.status_change == 1 ? true : false;
        shuttleStatusLog.status_change_text = data.status_change_text;
        return shuttleStatusLog;
    }
    static buildShuttleInfoPanel(data) {
        const shuttleInfoPanel = new ShuttleInfoPanel();
        shuttleInfoPanel.id = data.id;
        shuttleInfoPanel.auth = data.auth;
        shuttleInfoPanel.id_lot = data.id_lot;
        shuttleInfoPanel.id_product = data.id_product;
        shuttleInfoPanel.id_terminal = data.id_terminal;
        return shuttleInfoPanel;
    }
    static buildShuttleInfoPanelList(data) {
        const shuttleInfoPanelList = new ShuttleInfoPanelList();
        shuttleInfoPanelList.page = data.page;
        shuttleInfoPanelList.pagination = data.pagination;
        shuttleInfoPanelList.totalCount = data.total;
        shuttleInfoPanelList.totalPages = data.total_pages;
        shuttleInfoPanelList.shuttle_info_panels = _.map(data.shuttle_info_panels, (shuttleInfoPanel) => {
            return this.buildShuttleInfoPanel(shuttleInfoPanel);
        });
        return shuttleInfoPanelList;
    }
    static buildShuttlePanelSlide(data) {
        const shuttlePanelSlide = new ShuttlePanelSlide();
        shuttlePanelSlide.id = data.id;
        shuttlePanelSlide.id_shuttle_info_panel = data.id_shuttle_info_panel;
        shuttlePanelSlide.data = data.data;
        return shuttlePanelSlide;
    }
    static buildShuttlePanelSlideList(data) {
        const shuttlePanelSlideList = new ShuttlePanelSlideList();
        shuttlePanelSlideList.page = data.page;
        shuttlePanelSlideList.pagination = data.pagination;
        shuttlePanelSlideList.totalCount = data.total;
        shuttlePanelSlideList.totalPages = data.total_pages;
        shuttlePanelSlideList.shuttle_panel_slides = _.map(data.shuttle_panel_slides, (shuttlePanelSlide) => {
            return this.buildShuttlePanelSlide(shuttlePanelSlide);
        });
        return shuttlePanelSlideList;
    }
}
//# sourceMappingURL=shuttle-builder.js.map